import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_MENTOR_REQUEST = 'FETCH_MENTOR_REQUEST';
export const FETCH_MENTOR_SUCCESS = 'FETCH_MENTOR_SUCCESS';
export const FETCH_MENTOR_FAILURE = 'FETCH_MENTOR_FAILURE';

const buildMentorUrl = (groupId) => buildUrl(`/groups/${groupId}/mentor-results`);
const method = 'GET';

export function fetchMentorIfNeeded(groupId) {
  return (dispatch, getState) => {
    if (! ApiCall.shouldPerform(getState(), { method, url: buildMentorUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchMentor(groupId));
  };
}

export function isLoading(state, groupId) {
  const apiState = ApiCall.find(state, { method, url: buildMentorUrl(groupId) });
  return ApiCall.State.isValue(apiState) && ApiCall.State.isLoading(apiState);
}

export function fetchMentor(groupId) {
  return (dispatch) => {
    const url = buildMentorUrl(groupId);
    return dispatch(fetchMentorRequest()).payload
      .then((response) => dispatch(fetchMentorSuccess(response)))
      .catch((error) => dispatch(fetchMentorFailure(error)));

    function fetchMentorRequest() {
      return ApiCall.createAction({
        type: FETCH_MENTOR_REQUEST,
        payload: fetch(url),
        url,
        method,
        groupId,
      });
    }

    function fetchMentorSuccess(payload) {
      return ApiCall.createAction({
        type: FETCH_MENTOR_SUCCESS,
        payload,
        url,
        method,
        groupId,
      });
    }

    function fetchMentorFailure(error) {
      return ApiCall.createAction({
        type: FETCH_MENTOR_FAILURE,
        error,
        url,
        method,
        groupId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/Mentor/actions.js